<template>
  <div>
    <el-table :data="codelist" style="width: 100%"  height="630">
      <el-table-column label="国家码">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <!-- <span style="margin-left: 10px">{{ scope.row.locale.toUpperCase().slice(0,5) }}</span> -->
          <span style="margin-left: 10px">{{ scope.row.locale }}</span>
        </template>
      </el-table-column>
      <el-table-column label="国家区号">                
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top"> -->
          <!-- <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p> -->
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.code }}</span>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column label="中文">
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top"> -->
          <!-- <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p> -->
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.zh }}</span>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column label="英文">
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top"> -->
          <!-- <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p> -->
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.en }}</span>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">

          <div slot="reference" class="name-wrapper">
            <el-switch
              active-color="#13ce66"
            
              @change="handleCodeStatusChange(scope.row, $event)"
              :value="scope.row.status ? true : false"
            ></el-switch>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="修改国家码"
      width="800px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="updateObj"
        :rules="rules"
        ref="updateObj"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="中文" prop="zh">
          <el-input
            v-model="updateObj.zh"
            placeholder="请输入国家名称(中文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文" prop="en">
          <el-input
            v-model="updateObj.en"
            placeholder="请输入国家名称(英文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家区号" prop="code">
          <el-input
            v-model="updateObj.code"
            placeholder="请输入国家区号，例如中国为86"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家码" prop="locale">
          <el-input
            v-model="updateObj.locale"
            placeholder="例如中国为CHN"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="ruleForm.status" ></el-input> -->

          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为选中，红色则为未选中"
            placement="right"
          >
            <el-switch
              v-model="updateObj.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="updateCode('updateObj')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('updateObj')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')"
          >保存</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
  props:['currentPage','currentSize','zh'],
  data() {
    return {
      dialogVisibleChange: false,
      result:true,
      ruleForm: {
        zh: "",
        locale: "",
        code: "",
        en: "",
        status: 0,
      },
      updateObj:{},
      upperList:[],
      rules: {
        zh: [
          { required: true, message: "请输入国家名称（中文）", trigger: "blur" },
          // { min: 2, max: 8, message: "长度在 2 到 8 个字符", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入国家区号", trigger: "blur" },
          // { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        en: [
          { required: true, message:'请输入国家名称（英文）', trigger: "blur" },
        ],
        locale: [
          { required: true, message: "请输入国家码", trigger: "blur" },
          // { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
      },
      // rules: {
      //   zh: [
      //     {
      //       required: true,
      //       validator: ValidateZH,
      //       trigger: "blur",
      //     },
      //     {
      //       min: 2,
      //       max: 10,
      //       message: "长度在 2 到 10 个字符",
      //       trigger: "blur",
      //     },
      //   ],
      //   en: [
      //     { required: true, validator: ValidateEN, trigger: "blur" },
      //     {
      //       min: 2,
      //       max: 14,
      //       message: "长度在 2 到 14 个字符",
      //       trigger: "blur",
      //     },
      //   ],
      //   code: [
      //     {
      //       required: true,
      //       validator: ValidateCode,
      //       trigger: "blur",
      //     },
      //     { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
      //   ],
      //   locale: [
      //     {
      //       required: true,
      //       validator: ValidateLocale,
      //       trigger: "blur",
      //     },
      //     // { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
      //   ],
      // },
    };
  },
  mounted() {
  
    this.getDataList({page:this.currentPage,size:this.currentSize,zh:this.zh});

  },
  computed: {
    ...mapState("countryCode", ["codelist"]),
    ...mapGetters('countryCode',['filterList']),
    list(){
      return this.filterList.map(item=>item.locale.toUpperCase())
    }
  },
  methods: {
    ...mapActions("countryCode", ["getlist", "delOne", "updateOne"]),
    async getDataList({page,size,zh}) {
      const res = await this.getlist({zh,page,size});
    
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    handleEdit(index, row) {
      this.dialogVisibleChange = true;
      // this.ruleForm = Object.assign(this.ruleForm, { ...row });
      this.updateObj= { ...row,status:Boolean(row.status) };
    },
     handleDelete(index, row) {
      this.$confirm('此操作将永久删除该选项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
      const id = row.id;
      const res = await this.delOne(id);
      if (res.data == 1) {
        this.$message.success("操作成功");
        this.getDataList({page:this.currentPage,size:this.currentSize,zh:this.zh});
      } else {
        this.$message.error("操作失败！请重试");
      }
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
     
    },
    hadnleLanguageTypeChange(coinType, status) {

    },
    handleCodeStatusChange(row, status) {
      const message = status
        ? "确认要开启当前国家码状态吗？"
        : "确认要关当前国家码？关闭该国家码，相应的选项也将关闭。";

      this.$confirm(message, "提示", { type: "warning" }).then(async () => {

        if(row.status===0){
          row.status=1
         
         const res=await this.updateOne(row)
    
         if(res.data==1){
          this.$message.success('操作成功')
         }
        }else if(row.status===1){
           row.status=0
    
         const res=await this.updateOne(row)
         if(res.data==1){
          this.$message.success('操作成功')
         }
         }

      });
    },
     updateCode(formName) {
      this.updateObj.status = Number(this.updateObj.status);
      this.$refs[formName].validate(async(valid)=>{
        if(valid){
          const res = await this.updateOne(this.updateObj);
     
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.dialogVisibleChange = false;
          this.getDataList({page:this.currentPage,size:this.currentSize,zh:this.zh});
        }
      
        }
      })
    
    },
    resetForm(formName) {
      this.updateObj={
        zh: "",
        locale: "",
        code: "",
        en: "",
        status: false,
      }
      this.$refs[formName].resetFields();
     
    },
    closeDialog(){}
  },
};
</script>

<style lang="less" scoped></style>
